import Learning from "@/app/(app)/(crew)/learning";

export default Learning;
